var map = {
	"./0rbt.svg": "2182",
	"./acnh.png": "ef50",
	"./ans.png": "0e02",
	"./aocred.svg": "e774",
	"./ar.png": "393f",
	"./ardrive.png": "247f",
	"./arg.png": "e9b1",
	"./bank.png": "e5e1",
	"./bnb.png": "bc67",
	"./bp.png": "90f6",
	"./cfx.png": "8e50",
	"./dai.png": "e86a6",
	"./default.svg": "b4fb",
	"./dodo.png": "38c1",
	"./drop.png": "061b",
	"./eth.png": "c67a",
	"./everpay.png": "68ee",
	"./exp(ario).svg": "03f1",
	"./fox.png": "8664",
	"./fra.png": "7dd7",
	"./glmr.png": "b0ac",
	"./halo.svg": "2fe9",
	"./lat.png": "3160",
	"./map.svg": "46eb",
	"./mapo.png": "d59b",
	"./mask.png": "e028",
	"./moon.png": "4c4a",
	"./nexp.svg": "ecd0",
	"./psn-halo.svg": "983e",
	"./raven.png": "875e",
	"./sarco.png": "beba",
	"./sos.png": "548c",
	"./stamp.png": "77fa",
	"./t4ever.png": "a009",
	"./trunk(ao).svg": "3469",
	"./trunk.svg": "0540",
	"./u.png": "9873",
	"./uni.png": "b009",
	"./usdc.png": "012e",
	"./usdt.png": "5d28",
	"./vrt.png": "e7e1",
	"./war.png": "6d90",
	"./wbtc.png": "94aa",
	"./xsgd.png": "25f0",
	"./xyz.png": "ee79",
	"./zlk.png": "558e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23b0";